<template>
    <i data-locator="icon" class="icon" :class="classes"></i>
</template>

<script>
export default {
    name: 'Icon',

    props: {
        type: {
            required: true,
            type: String
        },

        size: {
            required: false,
            type: String,
            default: '16'
        },

        color: {
            required: false,
            type: String
        }
    },

    computed: {
        classes () {
            return `icon--${this.type} icon--${this.size}` + (this.color ? ` icon--${this.color}` : '')
        }
    }
}
</script>
